<template>
  <div>
    <van-popup
      v-model="isShowPep"
      position="right"
      :style="{ height: '100%', width: '100%', background: '#f9f9f9' }">
      <div class="add-pep">
        <van-nav-bar style="flex:1">
          <div slot="left" @click="close">
            <van-icon name="arrow-left" color="#333" size="19" />
          </div>
          <div slot="title">{{titles}}</div>
        </van-nav-bar>
        <div class="addpep-wrap" id="scrollTopDom">
          <div class="bre">
            <div class="bre-active" @click="addPepBtn">所有校区</div>
            <div v-for="(item,index) in activeOrgList" :key="index" class="bre-child" @click="handleClick(item,index)">
              <van-icon name="arrow" />
              <span :class="item.IsActive?'active':''">{{item.OrganizationName}}</span>
            </div>
          </div>
          <div
            v-for="(item,index) in teaList"
            :key="index"
            class="addpep-flex van-hairline--bottom"
            @click="level2Btn(item)">
            <span>{{item.OrganizationName}}（{{item.OrganizationPeopleCount}}人）</span>
            <van-icon name="arrow" />
          </div>
          <van-pull-refresh v-model="isLoading" @refresh="onRefresh" v-if="organizationId<0||organizationId>0" style="margin-top:10px;">
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
              <div
                v-for="(item,index) in list"
                :key="index"
                class="list-wrap van-hairline--bottom"
                @click="choiceBtn(item)">
                <span class="checkbox" :class="item.IsChecked?'active':''">
                  <van-icon name="success" color="#fff" />
                </span>
                <span v-if="item.Icon===''" class="icons">{{xy.showName(item.FullName)}}</span>
                <img v-else :src="xyMApi+'/base'+item.Icon" class="icons-img" alt="">
                <span class="text">{{item.FullName}}</span>
              </div>
            </van-list>
          </van-pull-refresh>
        </div>
        <div class="search-footer van-hairline--top" style="flex:1">
          <div class="cancel">已选：<span>{{checkedList.length}}</span>人</div>
          <div class="submit" @click="submitBtn">确定</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  name:'AddPep',
  props:{
    titles:{
      type:String,
      default:'添加流转人员'
    },
    isShowPep: {
      type: Boolean,
      required: false
    },
    addPepList:{
      type: Array,
      required: false
    }
  },
  data(){
    return {
      organizationId:0,
      schoolId:0,
      list:[],
      nums:0,
      teaList:[],
      activeOrgList:[],
      loading: false, // 是否加载中
      finished: false, // 加载是否完成
      isLoading: false, //是否处于下拉刷新状态
      num: 1,
      pageSize: 20,
      checkedList:[]
    }
  },
  watch:{
    isShowPep:{
      handler(newVal){
        if(newVal){
          this.addPepBtn()
        }
      },
      immediate:true
    }
  },
  methods:{
    close() {
      this.$emit("listenToChildClose", false);
    },
    async addPepBtn(){
      this.organizationId=0
      this.activeOrgList=[]
      this.xy.loading()
      let rs = await this.xyapi.get(this.xyMApi + '/base/api/Teacher/GetTeacherOrganizationAll')
        if (rs.success) {
          if (rs.data.length > 0) {
            this.teaList=rs.data
            this.list=[]
            this.$emit("listenToChildClose", true);
          }else{
            this.xy.msgError('暂无教师组织')
            this.$emit("listenToChildClose", false);
          }
        }
        this.xy.unloading()
    },
    async level2Btn(item){
      let dom = document.querySelector('#scrollTopDom')
      dom.scrollTop = 0
      this.activeOrgList.push(item)
      this.activeOrgList.map((item,index)=>{
        if(index===this.activeOrgList.length-1){
          this.$set(item,'IsActive',false)
        }else{
          this.$set(item,'IsActive',true)
        }
      })
      this.teaList=item.OrganizationListItem
      this.organizationId=item.OrganizationID
      this.schoolId=item.SchoolDistrictID
      this.onRefresh()
    },
    handleClick(item,index){
      this.teaList=item.OrganizationListItem
      this.activeOrgList.splice(index+1,(this.activeOrgList.length-1)-index)
      this.organizationId=item.OrganizationID
      this.schoolId=item.SchoolDistrictID
      this.list=[]
      this.onRefresh()
    },
    async onLoad() {
      if(this.organizationId<0||this.organizationId>0){
        let res = await this.xyapi.get(`${this.xyMApi}/base/api/Teacher/GetPage`, {
          PageIndex: this.num,
          PageSize: this.pageSize,
          organizationId: this.organizationId,
          schoolId: this.schoolId,
          dutyId: 0,
          isIcon: 0,
          isSex:0,
          isLock:0,
          isWechat:0,
          searchText:''
        })
        res.data.data.map(item=>{
          return this.$set(item,'IsChecked',false)
        })
        let _list = res.data.data
        this.list = [...this.list, ..._list];
        for(let i=0,len=this.list.length;i<len;i++){
          for(let j=0,jlen=this.checkedList.length;j<jlen;j++){
            if(this.checkedList[j].UserID===this.list[i].UserID){
              this.list[i].IsChecked=true
            }
          }
        }
        this.loading = false;
        this.num++;
        this.finished = this.list.length >= res.data.totalRecords ? true : false;
      }else{
        this.num=0
        this.loading = false;
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.list = [];
        this.num = 1;
        this.isLoading = false;
        this.onLoad();
      }, 500);
    },
    choiceBtn(val){
      let indexs = -1
      val.IsChecked=!val.IsChecked
      if(val.IsChecked){
        this.checkedList.push(val)
      }else{
        for(let i=0,len=this.checkedList.length;i<len;i++){
          if(this.checkedList[i].UserID ===val.UserID){
            indexs=i
          }
        }
      }
      if(indexs!==-1)
        this.checkedList.splice(indexs,1)
    },
    submitBtn(){
      this.$emit("listenToChildChoice", this.checkedList)
    }
  }
}
</script>
<style lang="less" scoped>
.add-pep{
  display: flex;
  flex-flow: column;
  height:100%;
}
.addpep-wrap{
  height: calc(100% - 200px);
  overflow-y: auto;
  .list-wrap{
    height: 100px;
    display: flex;
    align-items: center;
    padding-left:30px;
    background: #fff;
    .checkbox{
      width:40px;
      height:40px;
      display: flex;
      justify-content: center;
      align-items: center;
      background:rgba(255,255,255,1);
      border:1px solid rgba(144,147,151,1);
      border-radius:50%;
      margin-right:30px;
    }
    .checkbox.active{
      border-color:rgba(41,128,254,1);
      background:rgba(41,128,254,1);
    }
    .icons-img{
      width:76px;
      height:76px;
      border-radius:50%;
      margin-right:30px;
    }
    .icons{
      display: flex;
      justify-content: center;
      align-items: center;
      width:76px;
      height:76px;
      color:#fff;
      background:rgba(41,128,254,1);
      border-radius:50%;
      margin-right:30px;
    }
    .text{
      font-size:30px;
      color:rgba(51,51,51,1);
    }
  }
  .bre{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding: 20px 30px;
    background: #fff;
    margin:20px 0 0;
    .bre-active{
      color:#4196ff;
      display: flex;
      align-items: center;
      margin-bottom: 1.333vw;
    }
    .bre-child{
      display: flex;
      align-items: center;
      margin-bottom: 10px;
    }
    .bre-child.active{
      color:#4196ff;
      margin-bottom: 10px;
    }
  }
  .addpep-flex{
    height: 100px;
    padding:0 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
  }
}
.search-footer{
  display: flex;
  justify-content: space-between;
  padding:20px;
  background: #fff;
  .cancel{
    display: flex;
    justify-content: center;
    align-items: center;
    color:#267DFF;
  }
  .submit{
    color:#fff;
    width:346px;
    height:88px;
    border-radius: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size:30px;
    background:rgba(41,128,254,1);
  }
}
</style>
